/* Section: hero — slideshow.
   Behavior: auto-advance, prev/next arrows, dot jumps, keyboard arrows,
   pause on hover/focus, respects prefers-reduced-motion. */
(() => {
  const hero = document.querySelector('[data-section="hero"]');
  if (!hero) return;

  const slides = Array.from(hero.querySelectorAll('.hero__slide'));
  const dots = Array.from(hero.querySelectorAll('.hero__dot'));
  const prev = hero.querySelector('.hero__arrow--prev');
  const next = hero.querySelector('.hero__arrow--next');
  if (slides.length <= 1) return;

  const DURATION = 6500;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let index = slides.findIndex((s) => s.classList.contains('hero__slide--active'));
  if (index < 0) index = 0;
  let timer = null;

  const goTo = (i) => {
    index = (i + slides.length) % slides.length;
    slides.forEach((s, n) => s.classList.toggle('hero__slide--active', n === index));
    dots.forEach((d, n) => d.classList.toggle('hero__dot--active', n === index));
  };

  const start = () => {
    if (reduceMotion) return;
    stop();
    timer = setInterval(() => goTo(index + 1), DURATION);
  };
  const stop = () => {
    if (timer) { clearInterval(timer); timer = null; }
  };

  prev?.addEventListener('click', () => { goTo(index - 1); start(); });
  next?.addEventListener('click', () => { goTo(index + 1); start(); });
  dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); start(); }));

  // pause while the user is interacting
  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  hero.addEventListener('focusin', stop);
  hero.addEventListener('focusout', start);

  // keyboard arrows when hero is in view & focused area
  hero.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  { goTo(index - 1); start(); }
    if (e.key === 'ArrowRight') { goTo(index + 1); start(); }
  });

  // pause when tab is hidden, resume on return
  document.addEventListener('visibilitychange', () => {
    document.hidden ? stop() : start();
  });

  start();
})();
